import React from "react";

const AboutHero = () => {
	return (
		<section className="bg-inherit">
			<div className="max-w-7xl mx-auto px-4 pt-2">
				{/* Mission Statement */}
				<div className="text-left mb-[3rem]">
					<p className="text-l sm:text-xl lg:text-xl xl:text-2xl text-swift-dark leading-relaxed font-generalSans font-light mx-auto">
						Our mission is to advance health equity and dignity for
						girls across Africa by building a community-powered
						health network. Through technology, education, and peer
						support, we are removing barriers to their well-being
						and empowering them to thrive, ensuring they can reach
						their full potential.
					</p>
				</div>

				{/* Greenhouse Photo */}
				<div className="relative w-full">
					<img
						src="/assets/images/Swift-Group.JPG"
						alt="Woman holding harvested bell peppers in a greenhouse"
						className="w-full h-auto rounded-lg shadow-lg object-cover"
						style={{
							maxHeight: "800px",
							minHeight: "400px",
						}}
					/>
				</div>
			</div>
		</section>
	);
};

export default AboutHero;
